import { render } from "./StackItem.vue?vue&type=template&id=790345ba&scoped=true"
import script from "./StackItem.vue?vue&type=script&lang=js"
export * from "./StackItem.vue?vue&type=script&lang=js"

import "./StackItem.vue?vue&type=style&index=0&id=790345ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790345ba"]])

export default __exports__